// src/NewPage.js
import React, {createContext, useContext, useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ContentLeft = () => {
    const query = useQuery();
    const t = query.get('t');
    const [rootCategories, setRootCategories] = useState([]);


    useEffect(() => {
        const fetchData = () => {
            fetch("/api/category/root").then(response=>response.json()).then(data=>{
                setRootCategories(data.data)
            })
        };

        fetchData();
    }, []);

    return (
        <div className="col-12 col-sm-3 content-2columns-left">
            <div className="sidebar-filter-container">
            </div>
            <h1>浏览数据</h1>
            <ul className="list-bullets">
            </ul>
            <h2>数据分类</h2>
            <ul className="list-bullets">
                {
                    rootCategories.map((item,index) => (
                        <li><a href={'/categories/'+item.id} className="need-help">{item.name}</a></li>
                    ))
                }

            </ul>
            <h2 id="sidebar-need-help" tabIndex={0}>需要帮助?</h2>
            <ul className="list-bullets">
                <li><a id="sidebar-tutorials" className="need-help" href="javascript:void(0)">教程</a></li>
                <li><a id="sidebar-faq" className="need-help" href="javascript:void(0)"
                       aria-label="Frequently asked questions">常见问题</a></li>
                <li><a id="sidebar-email-us" className="need-help" href="javascript:void(0)">给我们留言</a></li>
            </ul>
        </div>
    )

}


export default ContentLeft;
